var _effectorFileName = "/builds/gmini/front-common/src/Explorer/Nodes/NewNodeRender.tsx";
import * as React from 'react';
import { useStore } from 'effector-react';
import * as smApi from '@gmini/sm-api-sdk';
import { closeItemForm, creationUpdate } from "../Model";
import { useBaseRenderProps } from "../BaseRenderProps";
import { NodeNameForm } from "../NodeNameForm";
import { usePending } from "../PendingContext";
import { jsx as _jsx } from "react/jsx-runtime";
export var NewItemRender = /*#__PURE__*/React.memo(function (_ref) {
  var type = _ref.itemType,
      parentCategoryId = _ref.parentCategoryId;

  var _ref2 = useBaseRenderProps() || {},
      onCreate = _ref2.onCreate,
      selectedProject = _ref2.selectedProject;

  var _usePending = usePending(),
      pending = _usePending.pending,
      ifPromise = _usePending.ifPromise;

  var fetchPending = useStore(smApi.UserClassifierRepoFolder.fetch.defaultContext.pending$, {
    loc: {
      file: _effectorFileName,
      line: 21,
      column: 23
    },
    name: "NewItemRender",
    sid: "NewItemRender /src/Explorer/Nodes/NewNodeRender.tsx [21, 23]"
  });
  var onSubmit = React.useCallback(function (_, name) {
    if (onCreate && selectedProject) {
      var _ifPromise;

      (_ifPromise = ifPromise(onCreate({
        name: name,
        type: type,
        parentCategoryId: parentCategoryId,
        projectUrn: selectedProject.urn
      }))) === null || _ifPromise === void 0 ? void 0 : _ifPromise.then(closeItemForm);
    }
  }, [ifPromise, onCreate, parentCategoryId, type, selectedProject]);
  return /*#__PURE__*/_jsx(NodeNameForm, {
    icon: /*#__PURE__*/_jsx(Icon, {
      itemType: type
    }),
    pending: pending,
    onClose: closeItemForm,
    onSubmit: onSubmit,
    submitDisabled: fetchPending,
    creationUpdate: creationUpdate
  });
});
NewItemRender.displayName = 'NewItemRender';
var Icon = /*#__PURE__*/React.memo(function (_ref3) {
  var itemType = _ref3.itemType;

  var _ref4 = useBaseRenderProps() || {},
      _ref4$categoryEmptyIc = _ref4.categoryEmptyIcon,
      categoryEmptyIcon = _ref4$categoryEmptyIc === void 0 ? null : _ref4$categoryEmptyIc,
      _ref4$entityIcon = _ref4.entityIcon,
      entityIcon = _ref4$entityIcon === void 0 ? null : _ref4$entityIcon,
      _ref4$assemblyIcon = _ref4.assemblyIcon,
      assemblyIcon = _ref4$assemblyIcon === void 0 ? null : _ref4$assemblyIcon;

  switch (itemType) {
    case 'Category':
      return categoryEmptyIcon;

    case 'Entity':
      return entityIcon;

    case 'Assembly':
      return assemblyIcon;
  }
});